function buildOrigin() {
    const {
        hostname,
        protocol,
        port,
    } = window.location;
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}

export { buildOrigin };

export default function stringToUrl(url = '/') {
    // IE compatible
    let {
        origin,
    } = window.location;
    if (!origin) {
        origin = buildOrigin();
    }

    if (url === null) {
        return new URL(`${origin}/`);
    }
    if (url.indexOf('http') === 0) {
        return new URL(url);
    }
    if (url.indexOf('//') === 0) {
        return new URL(`${window.location.protocol}${url}`);
    }
    if (url.indexOf('/') === 0) {
        return new URL(`${origin}${url}`);
    }
    return new URL(`${origin}/${url}`);
}
